import React from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import Icons from "@/assets/icons";
import { useQuery } from "@tanstack/react-query";
import RefundProcessServices from "@/services/refundProcessServices";
import { router } from "expo-router";
import useWindow from "@/hooks/useWindow";
import { getGlobalSessionId } from "@/services";

export default function SettingTipSection() {
  const { isDesktop } = useWindow();
  const sessionId = getGlobalSessionId();
  const { data: linkedEmails } = useQuery({
    queryKey: ["linkedEmails"],
    enabled: !!sessionId,
    queryFn: RefundProcessServices.getLinkedEmail,
  });

  const isLinkedEmail = !!linkedEmails?.length;

  if (isLinkedEmail) {
    return null;
  }

  return (
    <View style={[styles.wrapper, isDesktop ? styles.wrapperDesktop : styles.wrapperMobile]}>
      <View style={styles.container}>
        <Text style={styles.sectionTitle}>Finish setting up your account</Text>
        <TouchableOpacity
          style={styles.card}
          onPress={() => router.push("/account/linked-emails")}
        >
          <View style={styles.contentRow}>
            <Icons.Mail width={24} height={24} color="#0F9129" />
            <View style={styles.textContent}>
              <Text style={styles.title}>Add email account</Text>
              <Text style={styles.description}>
                Link your email for more claims
              </Text>
            </View>
            <Icons.ChevronRightGreen width={16} height={16} />
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "#F3F3F3",
    borderRadius: 16,
  },
  wrapperMobile: {
    marginBottom: 12,
    marginHorizontal: 16,
  },
  wrapperDesktop: {
    alignSelf: "flex-start",
    marginRight: 24,
  },
  container: {
    backgroundColor: "#F3F3F3",
    borderRadius: 16,
    padding: 24,
    gap: 12,
  },
  sectionTitle: {
    fontSize: 16,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "rgba(22, 29, 20, 0.7)",
    lineHeight: 25,
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    paddingHorizontal: 15,
    paddingVertical: 12,
  },
  contentRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  textContent: {
    flex: 1,
  },
  title: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.SemiBold,
    color: "#161D14",
    lineHeight: 23,
  },
  description: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#161D14",
    lineHeight: 23,
  },
});
